// import { DataSourceCategory } from './../../../../../../shared/enums/data-source-category';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { ZcVersionCalcProcessSettingsComponent } from '../../../dialogs/app-zc-version-calc-process-settings-dialog/app-zc-version-calc-process-settings-dialog.component';
import { Component, Input } from '@angular/core';
import { ZoningCode, ZoningCodeVersion } from 'src/app/modules/instance/models';
import { ZoningCodeVersionService, InstanceService, ZoningCodeService } from 'src/app/modules/instance/services';
import { ZoningCodeVersionButtons } from 'src/app/modules/instance/models';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import * as _ from 'lodash';
import { IDialogDataLayers } from 'src/app/shared/interfaces/dialog-data-layers';
import { appSettings } from 'src/settings/config';

@Component({
    standalone: false,
    selector: 'app-zoning-code-version-recalculate-with-settings-button',
    templateUrl: './zoning-code-version-recalculate-with-settings-button.component.html',
    styleUrls: ['./zoning-code-version-recalculate-with-settings-button.component.scss']
})
export class ZoningCodeVersionRecalculateWithSettingsButtonComponent extends ZoningCodeVersionButtons {
    constructor(
        private readonly zcVersionService: ZoningCodeVersionService,
        private readonly instanceService: InstanceService,
        private readonly dialog: MatDialog,
        private readonly zoningCodeService: ZoningCodeService
    ) {
        super();
    }

    ngOnInit(): void {}

    @Input()
    public zoningCode: ZoningCode;

    @Input()
    public zoningCodeVersion: ZoningCodeVersion;

    @Input()
    public task: ITaskModel;

    @Input()
    stateEnv: string;

    public recalculateZCVersion(event: Event) {
        event.stopPropagation();

        if (!this.zoningCodeVersion.hasTasks && !this.task) {
            this.openRecalculateTaskDialog();
            return;
        }

        this.openRecalculateTaskDialog();
    }

    get instance() {
        return this.task
            ? this.instanceService.getInstanceById(this.task.instanceId)
            : this.instanceService.selectedInstance;
    }

    private openRecalculateTaskDialog() {
        this.zoningCodeService.getZoningCodeRecordById(this.zoningCode.Id, this.stateEnv, true).subscribe(cachedZC => {
            const projectsDataSourceCategory = [_.get(cachedZC, 'ProjectsDataSourceCategory')].filter(dsc =>
                _.isNumber(dsc)
            );
            const dataSourceCategories = this.task ? this.task.dataSourceCategories : projectsDataSourceCategory;
            const maxPRsBunchSize = this.task ? this.task.maxPRsBunchSize : 1;
            const maxThreadsCount = this.task ? this.task.maxThreadsCount : 1;

            const dialogConfigConfirmation = new MatDialogConfig();
            dialogConfigConfirmation.autoFocus = true;
            dialogConfigConfirmation.data = {
                title: 'Start recalculation',
                topContent: 'The calculation is in process.',
                bottomContent: 'Do you want to stop it and start recalculation?',
                okButtonColor: 'warn'
            };

            const dialogConfig = new MatDialogConfig();
            dialogConfig.autoFocus = true;
            dialogConfig.data = {
                isCalculating: false,
                isReCalculating: true,
                dataSourceCategories,
                maxPRsBunchSize,
                maxThreadsCount,
                zoningCode: this.zoningCode,
                cachedZoningCode: cachedZC,
                useGAPIDataCache: _.isBoolean(_.get(this.task, 'useGAPIDataCache')) ? this.task.useGAPIDataCache : true,
                syncSolrData: this.task
                    ? _.isBoolean(_.get(this.task, 'syncSolrData'))
                    : appSettings.allowSyncSolrAUData,
                stateEnv: this.stateEnv
            } as IDialogDataLayers;
            dialogConfig.maxHeight = '850px';
            dialogConfig.width = '650px';
            dialogConfig.disableClose = true;

            this.dialog
                .open(ZcVersionCalcProcessSettingsComponent, dialogConfig)
                .afterClosed()
                .pipe(filter(isConfirm => isConfirm))
                .subscribe(value => {
                    if (!this.zoningCodeVersion.hasTasks) {
                        this.zcVersionService.recalculateZCVersion(
                            this.instance,
                            this.zoningCodeVersion,
                            this.zoningCode,
                            true,
                            value
                        );
                        return;
                    }
                    this.dialog
                        .open(ConfirmationDialogComponent, dialogConfigConfirmation)
                        .afterClosed()
                        .pipe(filter(isConfirm => isConfirm))
                        .subscribe(() => {
                            this.zcVersionService.recalculateZCVersion(
                                this.instance,
                                this.zoningCodeVersion,
                                this.zoningCode,
                                true,
                                value
                            );
                        });
                });
        });
    }
}
